import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import App from './pages/App';
import Login from './pages/Login';
import Registeration from './pages/Registration';
import ShowSearchResult from './pages/ShowSearchResult';
import ChangePassword from './pages/ChangePassword';
import ConfirmAccount from './pages/ConfirmAccount';

import { useState } from 'react';
import AppContext, { AppState } from './context/AppContext';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('token') ? (
          <Component {...props} />
        ) : (
          <Redirect to='/login' />
        )
      }
    />
  );
};

function Routes() {
  const [logo, changeLogo] = useState('');

  const appState: AppState = {
    logo,
    setLogo: (url: string) => {
      changeLogo(url);
    },
  };

  return (
    <Router>
      <AppContext.Provider value={appState}>
        <App />
        <Switch>
          <PrivateRoute exact path='/search' component={ShowSearchResult} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/register' component={Registeration} />
          <Route
            exact
            path='/users/reset'
            component={() => <ChangePassword forgotPage={true} />}
          />
          <Route
            exact
            path='/users/reset/:token'
            component={() => <ChangePassword forgotPage={false} />}
          />
          <Route
            exact
            path='/users/confirm/:token'
            component={() => <ConfirmAccount />}
          />
          <Route
            exact
            path='/'
            component={() => {
              return <Redirect to='/search' />;
            }}
          />
        </Switch>
      </AppContext.Provider>
    </Router>
  );
}
export default Routes;
